import { Alert, AlertDescription } from "@/components/ui/alert"

interface AdminErrorAlertProps {
  message: string
  onDismiss?: () => void
}

export function AdminErrorAlert({ message, onDismiss }: AdminErrorAlertProps) {
  if (!message) return null
  return (
    <Alert variant="destructive" className="mb-4">
      <AlertDescription className="flex items-center justify-between">
        <span>{message}</span>
        {onDismiss && (
          <button onClick={onDismiss} className="ml-2 text-destructive hover:opacity-70">
            &times;
          </button>
        )}
      </AlertDescription>
    </Alert>
  )
}
